import {
  IconButton,
  type IconButtonProps,
} from '@ace-clublabs/shared-component-library';

export interface SearchIconButtonProps {
  onClick?: () => void;
  loading?: boolean;
  variant?: 'search' | 'continue';
  sx?: IconButtonProps['sx'];
  'data-testid'?: string;
}

const SearchIconButton: React.FC<SearchIconButtonProps> = ({
  onClick,
  loading = false,
  variant = 'search',
  sx,
  'data-testid': dataTestId = 'search-icon-button',
}) => (
  <IconButton
    loading={loading}
    iconName={
      variant === 'continue'
        ? 'arrow-right-regular'
        : 'magnifying-glass-regular'
    }
    onClick={onClick}
    data-testid={dataTestId}
    sx={[
      {
        backgroundColor: 'primary.main',
        color: 'white',
        width: 46,
        height: 40,
        borderRadius: '12px',
        fontSize: '16px',
        '&:hover': {
          backgroundColor: 'primary.dark',
        },
        '&.MuiIconButton-loading': {
          backgroundColor: 'primary.main',
        },
        '& .MuiIconButton-loadingIndicator': {
          color: 'white',
        },
      },
      ...(Array.isArray(sx) ? sx : [sx]),
    ]}
  />
);

export default SearchIconButton;
